import React, {useEffect, useState} from "react";
import styled from "@emotion/styled";
import {bpMediumUp, bpSmallOnly} from "../../fonts/js-styles/MediaQueries";
import {hot} from "react-hot-loader";
import {css} from "@emotion/react";

const LabeledInput = styled.div({
	width:'100%',
	input:{
	    boxSizing:'border-box',
		padding: '12px 10px',
		width:'100%',
		border:'2px solid var(--rpp-fg)' ,
		backgroundColor:"var(--rpp-bg)",
		color: "var(--rpp-fg)",
		'&:focus,&:active':{
			backgroundColor:"var(--rpp-form-focus)",
			outline:'none',
		},
		'&.invalid':{
			border:'2px solid var(--rpp-error)',
			
		}
		// margin:10
	}
});

export const Input = ({ name, placeholder, register, range = null, minLength = 0, errorMsg ='', required=false, defaultValue='', errors, pattern = null, type='text' }) => {

    var ro:any = {required,minLength:minLength};
    if(pattern) ro.pattern = pattern;
    if(range) ro = {...ro,min:range[0],max:range[1]};
    
	const isError = !!errors[name];
	var en = errors[name] || {};
	var err = typeof errorMsg == 'string' ? errorMsg : errorMsg[en.type];
 
	return(
		<LabeledInput className={'labeled-input'}>
			<input placeholder={placeholder}  min={range ? range[0] : null} max={range ? range[1] : null} defaultValue={defaultValue} type={type} className={isError?'invalid':''} name={name} ref={register(ro)} />
			{isError && errorMsg &&
            <div className="error-msg">
				{err}
            </div>
			}
		</LabeledInput>
	);
};

const StyledDropDown = styled.div({
    width:'100%',
    position:'relative',
    svg:{
        position:'absolute',
        right:12,
        top:"50%",
        transform:'translateY(-50%) scale(1.4)',
        pointerEvents:'none',
    },
    select:{
        appearance:'none',
        boxSizing:'border-box',
        padding: '13px 10px',
        width:'100%',
        border:'none' ,
        borderRadius: 4,
        backgroundColor:"rgba(255,255,255, 0.2)",
        color: "var(--rpp-fg)",
    
        '&:focus,&:active':{
            outline:'none',
        },
        '&.unselected':{
            color:"rgba(255,255,255, 0.4)",
        },
        '&.invalid':{
            border:'2px solid var(--rpp-error)',
            padding: '11px 8px',
        }
        // margin:10
    }
});

export const DropDownBox  = ({ name, placeholder, register, options, required=false,errorMsg = "", errors }) => {

	const isError = !!errors[name];
	var en = errors[name] || {};
	var err = typeof errorMsg == 'string' ? errorMsg : errorMsg[en.type];
    
    const [value, setValue] = useState('');
    
    var opts:RadioBtnChoice[] = options; //[{val:"frauen", label:"Frauengruppe"}, {val:"maenner", label:"Männergruppe"}, {val:"gemischt", label:"Gemischte Gruppe"}];
    var optsWithPlaceholder = [{val:"", label:placeholder}, ...opts];
    return(
        <StyledDropDown className={'labeled-input'}>
            <svg width="10px" height="7px" viewBox="0 0 10 7" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                <title>hint-arrow</title>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Artboard" transform="translate(-116.000000, -399.000000)" stroke="#FFD900" strokeWidth="2">
                        <polyline id="hint-arrow" points="124.962549 400.5 121.037451 404.5 117.112353 400.5"></polyline>
                    </g>
                </g>
            </svg>
            
            <select name={name} required={required} className={(isError?'invalid ':'')+(value == "" ? "unselected" : "")} placeholder={placeholder} ref={register({required})} onChange={e => setValue(e.target.value)}>
                {optsWithPlaceholder.map((op,i) => <option key={i} value={op.val}>{op.label}</option>)}
            </select>
        </StyledDropDown>
    );
};





interface IFormCheckbox{
	label?,
	name,
	errorMsg?,
	initial?,
	onToggle?,
	register?
	errors?,
	required?,
	children?
}
const Checkbox = styled.input({
	cursor:'pointer',
	border: '2px solid var(--rpp-fg) !important',
	outline:'none !important',
	[bpSmallOnly]:{
		width:'20px !important',
		height:'20px !important',
	},
	'+label':{
		paddingLeft:10,
		display:'inline-block',
		paddingTop:4,
		marginBottom:10,
		lineHeight:1,
		verticalAlign:'top',
		cursor:'pointer',
	},
	position:'relative',
	marginTop:'4px !important',
	appearance:'none',
	width:25,
	height:25,
	'&:checked:after':{
		content: '""',
		display: 'block',
		left: '4px !important',
		top: '0px !important',
		position: 'absolute',
		width: '6px !important',
		height: '11px !important',
		border: '2px solid var(--rpp-fg)',
		borderColor: 'var(--rpp-fg) !important',
		borderTop: 0,
		borderLeft: 0,
		transform: 'rotate( 40deg)',
		[bpMediumUp]:{
			border: '3px solid var(--rpp-fg)',
			borderTop: 0,
			borderLeft: 0,
			left: '6px !important',
			width: '6px !important',
			height: '12px !important',
		}
	}
},css`
	appearance: none  !important;
`);
const StyledCheckbox = styled.div({
	'&.invalid input':{
		border: '3px solid var(--rpp-error) !important',
	},
    display:'flex',
    alignItems:'center',
    justifyContent:'flex-start'
});

export const FormCheckbox:React.FC<IFormCheckbox> = hot(module)(({children,label,name, errorMsg = '', initial = false, onToggle = null,register = null, errors = {},required = false}) => {
	const [curVal,setVal] = useState(initial);
	useEffect(()=>{
		if(curVal != initial) setVal(initial);
	},[initial]);
	var isError = !!errors[name];
	if(isError) isError = (required && !curVal);
	
	if(!register) register = (v)=>null;
	
	const clickFun = ()=>{
		setVal(!curVal);
		if(onToggle) onToggle(!curVal);
	};
	
	return(
		<StyledCheckbox className={'form-checkbox ' + (isError?'invalid':'')}>
			<Checkbox onClick={clickFun} onChange={()=> {}} name={name} type="checkbox" ref={register({required})} checked={curVal}/>
			<label onClick={clickFun}>
				{label &&
                <span dangerouslySetInnerHTML={{__html:label}} />
				}
				{children && !label &&
                <span>
						{children}
					</span>
				}
				{required &&
                <span className="require">*</span>
				}
			</label>
			{isError && errorMsg &&
            <div className="error-msg">
				{errorMsg}
            </div>
			}
		</StyledCheckbox>
	);
});


export type RadioBtnChoice = {val:string, label:string,desc?:string };
interface IRadioGroupProps{
	register?,
	required?:boolean,
	errorMsg?:string,
	errors?,
	fields:RadioBtnChoice[]
	initallySelectedVal?:string,
	groupID:string,
	twoCol?:boolean,
	onChangedSelected?:(f:{val:string,label:string}) => void
}

const RBG = styled.input({
	border: '3px solid var(--rpp-fg) !important',
	borderRadius:'50%',
	'&:focus, &:active':{
		outline:'none !important'
	},
	'&:checked':{
		'&:after':{
			backgroundColor: "var(--rpp-fg)",
		}
	},
	'+label':{
		paddingLeft:10,
		display:'inline-block',
		paddingTop:4,
		marginBottom:10,
		lineHeight:1,
		verticalAlign:'top',
		cursor:'pointer',
	},
	cursor:'pointer',
	marginBottom:10,
	appearance:'none',
	width: 25,
	height: 25,
	position:'relative',
	'&:after':{
		width:11,
		height:11,
		top:'4px !important',
		left:'4px !important',
		content:'""',
		position:'absolute',
		backgroundColor: 'transparent',
		borderRadius:'50%',
	}
},css`
	appearance: none  !important;
`);
const RBGContainer = styled.div({
	input:{
	}
});
export const RadioGroup:React.FC<IRadioGroupProps> = ({ twoCol = false, initallySelectedVal = null, onChangedSelected, register, groupID,errorMsg, required, errors, fields }) => {
	
	const curVal = useState(null);
	if(!register) register = ()=>null;
	if(!errors) errors = {};
	
	const isError = !!errors[groupID];
	return(
		<RBGContainer className={'radio-group-container ' + (twoCol ? 'two-col':'')}>
			{fields.map((f,idx)=>
				<div className="radio-btn"  key={idx} >
					<RBG defaultChecked={f.val == initallySelectedVal} onChange={()=>{
						if(onChangedSelected) onChangedSelected(f);
					}} id={`radio-btn-${groupID}-${idx}`} name={groupID} type="radio" value={f.val} ref={register({ required: required })}/>
					<label htmlFor={`radio-btn-${groupID}-${idx}`} dangerouslySetInnerHTML={{__html:f.label}}/>
					{f.desc &&
                    <span className={'radio-btn__desc'}>{f.desc}</span>
					}
				</div>
			)}
			{isError && errorMsg &&
            <div className="error-msg">{errorMsg}</div>
			}
		</RBGContainer>
	);
	
};
